import React from 'react';
import Copyright from './Copyright';
import { useTranslation } from 'react-i18next';
import { PrivacyPolicyURL, TermsOfUseURL } from '@/config';

export default function DefaultFooter() {
  const { t } = useTranslation();
  return (
    <footer className="footer -type-1 text-white bg-dark-2">
      <div className="container">
        <div className="pt-30 pb-30">
          <div className="row y-gap-40">
            <div className="col-12">
              <label className="text-16">For any problem regarding online hotel booking</label>
              <a href="mailto:omega_support@nta.co.jp" target="_blank" className="d-block text-18 fw-500 mb-10 fw-bold">
                omega_support@nta.co.jp
              </a>
            </div>
          </div>
          <div className="row y-gap-10 ">
            <div className="col-xl-2 col-lg-4 col-sm-6">
              <a href="https://www.ntainbound.com/about-japan" target="_blank" className="d-block text-18 fw-500">
                About Japan
              </a>
            </div>
            <div className="col-xl-2 col-lg-4 col-sm-6">
              <a href="https://www.ntainbound.com/" target="_blank" className="d-block text-18 fw-500 ">
                About Us
              </a>
            </div>
            <div className="col-xl-2 col-lg-4 col-sm-6">
              <a href={PrivacyPolicyURL} target="_blank" className="d-block text-18 fw-500">
                {t('footerCpn_Privacy')}
              </a>
            </div>
            <div className="col-xl-2 col-lg-4 col-sm-6">
              <a href={TermsOfUseURL} target="_blank" className="d-block text-18 fw-500">
                {t('footerCpn_Terms')}
              </a>
            </div>
          </div>
        </div>
        <div className="py-20 border-top-light">
          <Copyright />
        </div>
      </div>
    </footer>
  );
}
